import { ADDRESS_TYPE } from '@/api/type/commonTypes';

interface getAddressProps {
  countryCode: string;
  address: ADDRESS_TYPE;
}
export const getAddress = ({ countryCode, address }: getAddressProps) => {
  return countryCode === '+82'
    ? `(${address.postalCode}) ${address.address1} ${address.address2} ${address.city || ''} ${address.state || ''}`
    : `${address.address1} ${address.address2} ${address.city || ''} ${address.state || ''} (${address.postalCode})`;
};
